<template>
	<div>
		<div class="level">
			<div class="level-left">
				<div class="level-item"><h1 class="title">Torneos</h1></div>
			</div>
			<div class="level-right">
				<div class="level-item"><router-link :to="{name: 'torneo-new'}" class="button is-primary">+ Nuevo torneo</router-link></div>
			</div>
		</div>
		
		

		<table class="table is-bordered is-narrow is-fullwidth">
			<thead>
				<tr>
					<th>Id</th>
					<th>Nombre</th>
					<th>Estadisticas</th>
					<th class="is-hidden-mobile">Betclick</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="torneo in torneos" :key="torneo.id">
					<td>{{ torneo.id }}</td>
					<td>{{ torneo.nombre }}</td>
					<td>{{ torneo.mostrar_estadistica ? 'Si':'No' }}</td>
					<td class="is-hidden-mobile">{{ torneo.betclick }}</td>
					<td><router-link class="button is-small" :to="{name: 'torneo', params: {id: torneo.id}}">Edit</router-link></td>
				</tr>
			</tbody>
		</table>
	</div>

</template>

<script>
	import { mapState } from 'vuex'
	export default {

		name: 'Torneos',

		data() {
			return {

			};
		},
		computed: mapState('torneos',['torneos']),
		created(){
			this.$store.dispatch('torneos/fetchTorneos')
		}
	};
</script>

<style lang="css" scoped>
</style>
